import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import Icon from '../AppIcon';

const SubHeader = ({ pageTitle = 'لوحة التحكم' }) => {
  const navigate = useNavigate();

  const handleDashboardClick = () => {
    navigate('/');
  };

  return (
    <div className="bg-black border-b border-gold/20 shadow-lg sticky top-0 z-40">
      <div className="max-w-[1600px] mx-auto px-4 py-3">
        <div className="flex items-center justify-between gap-4">
          {/* Page Title */}
          <div className="flex items-center gap-3">
            <Icon name="LayoutDashboard" size={24} color="#D4AF37" />
            <h1 className="text-xl md:text-2xl font-bold text-white">{pageTitle}</h1>
          </div>

          {/* Action Buttons */}
          {/* {actions && (
            <div className="flex items-center gap-2">
              {actions}
            </div>
          )} */}
        </div>

        {/* Breadcrumbs */}
        {/* {breadcrumbs && breadcrumbs?.length > 0 && (
          <div className="flex items-center gap-2 mt-2 text-sm">
            {breadcrumbs?.map((crumb, index) => (
              <React.Fragment key={index}>
                {index > 0 && <Icon name="ChevronLeft" size={14} color="#6B7280" />}
                {crumb?.href ? (
                  <Link
                    to={crumb?.href}
                    className="text-gold hover:text-gold-light transition-colors"
                  >
                    {crumb?.label}
                  </Link>
                ) : (
                  <span className="text-white/60">{crumb?.label}</span>
                )}
              </React.Fragment>
            ))}
          </div>
        )} */}
      </div>
    </div>
  );
};

export default SubHeader;